import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        courseVersion: '=',
        canManageCourse: '=',
        course: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form ng-submit="vm.save()">
                <courses-courses-steps-version-licence
                    context="vm.context"
                    form="vm.form"
                    can-manage-course="vm.canManageCourse"
                    course="vm.course"
                />
                <ul class="actions01">
                    <li class="primary" ng-if="vm.canManageCourse && !vm.hasPublishedOccurrence  && !vm.course.isArchived">
                        <a ng-click="vm.save(true)" class="btn main">{{ 'general.Save' | translate }}</a>
                    </li>
                    <li>
                        <a ui-sref="authorized.courses.courses.edit.version.list()" class="btn discrete">
                            <span>{{ 'general.Back to list' | translate }}</span>
                        </a>
                    </li>
                </ul>
                <button type="submit" class="hidden" ng-if="vm.canManageCourse && !vm.hasPublishedOccurrence && !vm.course.isArchived">{{ 'general.Save changes' | translate }}</button>
            </form>
        </form-wrapper>
    `
})

export default class {
    constructor ($q, $translate, $scope, $state, CourseVersionService, ModalService,
                 CourseVersionResource, OccurrenceResource, FormFactory) {
        this.$q = $q;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$state = $state;
        this.CourseVersionResource = CourseVersionResource;
        this.CourseVersionService = CourseVersionService;
        this.OccurrenceResource = OccurrenceResource;
        this.ModalService = ModalService;
        this.FormFactory = FormFactory;
    }

    $onInit () {
        this.context = 'edit';
        this.CourseVersionService.nestCompositeModels(this.courseVersion);
        this.form = this.FormFactory.createFromResource(this.courseVersion, {
            expand: 'courseTrainings,scorm,courseTrainingI18ns,courseOccurrences,creator,updater,courseTrainingForms,courseVersionLicences,automatedPlanningGroups'
        });
        this.init();
        this.hasPublishedOccurrence = this.CourseVersionService.getPublishedOccurrenceCount(this.form.model);
    }

    init () {
        if (this.form.model.courseVersionLicences) {
            // convert existing licenceId's to strings to display select values
            this.form.model.courseVersionLicences.forEach(licence => {
                licence.licenceId = licence.licenceId.toString();
            });
        }
    }

    beforeSave () {
        this.CourseVersionService.mapTrainingForms(this.form.model.courseTrainings);
    }

    save () {
        this.beforeSave();
        return this.form.save().then((updatedVersion) => {
            this.courseVersion = updatedVersion;
            this.CourseVersionService.nestCompositeModels(this.courseVersion);
            this.form.model = updatedVersion;
            this.init();
            this.$scope.$emit('version:reload', updatedVersion);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/version/edit/licence/index.js